// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__2RQM0","box":"checkbox_box__3npR4","check":"checkbox_check__1QUYU","text":"checkbox_text__3bpPL"};